<nav class="pc-sidebar">
    <div class="navbar-wrapper">
        <div class="navbar-content">
            <ul class="pc-navbar1">
                <li *ngIf="token?.permissions?.viewMarketMatrics" class="pc-item" id="metrics"
                    (click)="makeActive('metrics')">
                    <a routerLink="/metrics" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-row-vertical"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Market Metrics</span>
                    </a>
                </li>
                <li class="pc-item" id="organization" (click)="makeActive('organization')"
                    *ngIf="token?.permissions?.viewOrganization">
                    <a routerLink="/organization" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-user"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Organizations</span>
                    </a>
                </li> 
                <li class="pc-item" id="lanes" (click)="makeActive('lanes')" *ngIf="token?.permissions?.viewLane">
                    <a routerLink="/lanes" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-kanban"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Lanes</span>
                    </a>
                </li>
                <li class="pc-item" id="user" (click)="makeActive('user')" *ngIf="token?.permissions?.viewUser">
                    <a routerLink="/user" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-user"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Users</span>
                    </a>
                </li>

                <li class="pc-item" id="blogs" (click)="makeActive('blogs')" *ngIf="token?.permissions?.viewBlogs">
                    <a routerLink="/blogs" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-notification-status"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Blogs</span>
                    </a>
                </li>
                <li class="pc-item" id="ports" (click)="makeActive('ports')" *ngIf="token?.permissions?.viewPorts">
                    <a routerLink="/ports" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-box-1"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Geo-heirarchy</span>
                    </a>
                </li>
                <li class="pc-item" id="plans" (click)="makeActive('plans')" *ngIf="token?.permissions?.viewPlans">
                    <a routerLink="/plans" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-notification-status"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Plans</span>
                    </a>
                </li>
                <li class="pc-item" id="terminology" (click)="makeActive('terminology')">
                    <a routerLink="/terminology" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-data"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Terminology</span>
                    </a>
                </li>

                @if(token?.userType !=  'superadmin' && token?.permissions?.buySellPrice)
                {
                    <li class="pc-item" id="price" (click)="makeActive('price')">
                        <a routerLink="/price" class="pc-link" href="javascript:void(0)">
                            <span class="pc-micon">
                                <svg class="pc-icon">
                                    <use xlink:href="#custom-document-upload"></use>
                                </svg>
                            </span>
                            <span class="pc-mtext">Add Your Prices</span>
                        </a>
                    </li>
                    <li class="pc-item" id="master" (click)="makeActive('master')">
                        <a routerLink="/master" class="pc-link" href="javascript:void(0)">
                            <span class="pc-micon">
                                <svg class="pc-icon">
                                    <use xlink:href="#custom-document-text"></use>
                                </svg>
                            </span>
                            <span class="pc-mtext">{{token?.userType == 'shipper' ? "Vendor": "Customer"}}  Master</span>
                        </a>
                    </li>
                } 
                <li class="pc-item" id="viewMap" (click)="makeActive('map')">
                    <a routerLink="/map" class="pc-link" href="javascript:void(0)">
                        <span class="pc-micon">
                            <svg class="pc-icon">
                                <use xlink:href="#custom-mouse-circle"></use>
                            </svg>
                        </span>
                        <span class="pc-mtext">Map</span>
                    </a>
                </li>    
            </ul>
        </div>
    </div>
</nav>